package dev.wyns.ventrova.data.model

/** How plant-based a venue is, matching the `veg_status` column of the places database. */
enum class VeganLevel(val databaseValue: String) {
    /** Everything on the menu is plant-based. */
    Vegan("vegan"),

    /** No meat or fish, lots of vegan. */
    Vegetarian("vegetarian"),

    /** Also serves meat or fish, with vegan dishes. */
    VeganOptions("vegan_options");

    companion object {
        fun fromDatabase(value: String): VeganLevel? = entries.firstOrNull { it.databaseValue == value }
    }
}
